import { takeLatest, call, put } from 'redux-saga/effects'
import getParticipant from 'api/administration/participants/Get'
import { onHttpError } from 'helpers/access.helper'
import * as fromActions from '../../actions/participants.action'

async function getParticipantById(id: number) {
  return await getParticipant(id)
}

function* participantsGetEffectSaga(action: any) {
  try {
    const { data } = yield call(getParticipantById, action.payload)
    if (data)
      yield put(fromActions.Actions.participantGetSuccess(data.data.attributes))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
}

export function* participantsGetWatcherSaga() {
  yield takeLatest(
    fromActions.PARTICIPANTS_PROFILES_GET,
    participantsGetEffectSaga
  )
}
